var _path, _a;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 7,
    viewBox: "0 0 11 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.22772 0.971191H9.25897C9.82147 0.971191 10.1027 1.65869 9.69647 2.06494L5.69647 6.06494C5.44647 6.31494 5.04022 6.31494 4.79022 6.06494L0.790222 2.06494C0.383972 1.65869 0.665222 0.971191 1.22772 0.971191Z",
    fill: "#656565"
  })), _a || (_a = /*#__PURE__*/React.createElement("a", {
    href: "https://www.figma.com/design/fH8K6KB6qAslIMUlMT6jND/Untitled?node-id=101-2"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillOpacity: 0,
    y: -1.2,
    width: 10,
    height: 18.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowdown);
export default __webpack_public_path__ + "static/media/arrowdown.9218608cb7cc330280591cb96ff5243a.svg";
export { ForwardRef as ReactComponent };